
import { rutinInfos } from './RutinInfo';
import {
  BusinessMenuButtons,
  ICustomAddButtonProps,
  ICustomBottomToolbarProps,
  IRoutine,
} from './Delsystem';
import LRRutiner from '../../Leverantor/Rutiner/LRRutiner';
import ARRutiner from '../../Anläggning/Rutiner/ARRutiner';
import BORutiner from '../../Bokning/Rutiner/BORutiner';
import DIRutiner from '../../Diarie/Rutiner/DIRutiner';
import EKRutiner from '../../Ekonomi/Rutiner/EKRutiner';
import GARutiner from '../../Grav/Rutiner/GARutiner';
import KRRutiner from '../../Kundreskontra/Rutiner/KRRutiner';
import MURutiner from '../../Musik/Rutiner/MURutiner';
import OFRutiner from '../../OrderFakt/Rutiner/OFRutiner';
import PURutiner from '../../PU/Rutiner/PURutiner';
import SYSRutiner from '../../SystemAdministration/Rutiner/SYSRutiner';
import TIRutiner from '../../Tidredovisning/Rutiner/TIRutiner';
import BJRutiner from '../../BisattningJournal/Rutiner/BJRutiner';
import getStandardRutin from '../Utils/getStandardRutin';
import { ICustomTopToolbarProps } from '../../Bokning/Rutiner/KalenderSideMenyToolbar';

export interface IOnStartWarningHookResult {
  loading: boolean;
  ok: boolean;
  warningText: string;
}
export type OnStartWarningHook = (
  isLoggedIn: boolean
) => IOnStartWarningHookResult;

export const rutiner: { [rtnKey: string]: IRoutine } = {
  //////////////////////////////////
  // Gemensamma
  //////////////////////////////////
  rtnBokforingsjournal: {
    component: getStandardRutin(
      rutinInfos.rtnBokforingsjournal,
      'EKBokfjournal'
    ),
  },
  rtnAdresser_HarUtgatt: {
    component: getStandardRutin(
      rutinInfos.rtnAdresser_HarUtgatt,
      'OPOrgPersLok'
    ),
  },
  rtnAdressbokKontakter: {
    component: getStandardRutin(rutinInfos.rtnAdressbokKontakter, 'OPKontakt'),
  },
  rtnEnhet: {
    component: getStandardRutin(rutinInfos.rtnEnhet, 'LAEnhet'),
  },
  rtnPostnr: {
    component: getStandardRutin(rutinInfos.rtnPostnr, 'SYSPOSTNR'),
  },
  rtnKund: {
    component: getStandardRutin(rutinInfos.rtnKund, 'KRKund'),
  },
  rtnArtiklar: {
    component: getStandardRutin(rutinInfos.rtnArtiklar, 'LAArtikel'),
  },
  rtnTvist: {
    component: getStandardRutin(rutinInfos.rtnTvist, 'OPTvist'),
  },
  rtnBegrByra: {
    component: getStandardRutin(rutinInfos.rtnBegrByra, 'OPOrgPersLok'), // Same as Adressbok
  },
  rtnOrgPersLok: {
    component: getStandardRutin(rutinInfos.rtnOrgPersLok, 'OPOrgPersLok'),
  },
  rtnVerifikation: {
    component: getStandardRutin(rutinInfos.rtnVerifikation, 'EKBokfver'),
  },

  ...LRRutiner,
  ...ARRutiner,
  ...BORutiner,
  ...BJRutiner,
  ...DIRutiner,
  ...EKRutiner,
  ...GARutiner,
  ...KRRutiner,
  ...MURutiner,
  ...OFRutiner,
  ...PURutiner,
  ...SYSRutiner,
  ...TIRutiner,
};

export const findRoutineMenuUnusedButtons = (
  rutinKod: string | undefined
): BusinessMenuButtons[] | undefined => {
  return rutinKod ? rutiner[rutinKod].unusedRoutineMenuButtons : undefined;
};

export const findRoutineMenuCustomUrvalButton = (
  rutinKod: string | undefined
): React.FunctionComponent<React.PropsWithChildren<unknown>> | undefined => {
  return rutinKod ? rutiner[rutinKod].customUrvalButton : undefined;
};

export const findRoutineMenuCustomAddButton = (
  rutinKod: string | undefined
):
  | React.FunctionComponent<React.PropsWithChildren<ICustomAddButtonProps>>
  | undefined => {
  return rutinKod ? rutiner[rutinKod].customAddButton : undefined;
};
export const findRoutineCustomBottomToolbar = (
  rutinKod: string | undefined
):
  | React.FunctionComponent<React.PropsWithChildren<ICustomBottomToolbarProps>>
  | undefined => {
  return rutinKod ? rutiner[rutinKod].customBottomToolbar : undefined;
};
export const findRoutineCustomTopToolbar = (
  rutinKod: string | undefined
):
  | React.FunctionComponent<React.PropsWithChildren<ICustomTopToolbarProps>>
  | undefined => {
  return rutinKod ? rutiner[rutinKod].customTopToolbar : undefined;
};

export const getRutinPanelFullHeight = (
  rutinKod: string | undefined
): boolean | undefined => {
  return rutinKod ? rutiner[rutinKod].rutinPanelFullHeight : undefined;
};

export const findRoutineDetaljVyCollectionName = (
  rutinKod: string | undefined
): string | undefined => {
  return rutinKod ? rutiner[rutinKod].detaljVyCollectionName : undefined;
};

export const findRoutineDetaljVyAssociationName = (
  rutinKod: string | undefined
): string | undefined => {
  return rutinKod ? rutiner[rutinKod].detaljVyAssociationName : undefined;
};
